<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex
        :key="i"
        pa-2
        v-for="(story, i) in stories"
      >
        <story-card v-if="!story.archived" :story="story"></story-card>
      </v-flex>
    </v-layout>
    <v-btn
      @click="goToAdd"
      bottom
      fab
      fixed
      right
      id="addStoryButton"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import StoryCard from '@/components/StoryCard.vue';

export default {
  name: 'StoriesView',
  components: { StoryCard },
  computed: {
    stories() {
      return this.$store.getters.getStories;
    },
  },
  methods: {
    goToAdd() {
      this.$router.push({ name: 'Add Story' });
    },
  },
};

</script>
